module.exports = __webpack_public_path__ + "static/media/tv-alt.25739092.svg";